import { MemberRole } from 'models/MemberRole';

export enum Role {
  GUEST = 'guest',
  COLLABORATOR = 'collaborator',
  MEMBER = 'member',
  MANAGER = 'manager',
  BILLING = 'billing',
  BILLING_MANAGER = 'billing_manager',
  ANONYMOUS = 'anonymous'
}

export type AccessTo = {
  customLogosAllowed: boolean;
  attachmentsDisabled: boolean;
  manageProject: boolean;
  viewMembers: boolean;
  viewGuests: boolean;
  viewKanbanProject: boolean;
  viewCollaborators: boolean;
  inviteGuest: boolean;
  inviteMember: boolean;
  inviteCollaborator: boolean;
  projectViewTasks: boolean;
  sidebarViewAssignedTasks: boolean;
  sidebarViewStatuses: boolean;
  taskEditAssignees: boolean;
  taskViewAssignees: boolean;
  taskEditTags: boolean;
  taskMoveToProject: boolean;
  taskMoveToFeedback: boolean;
  taskEditDueDate: boolean;
  taskEditSeverity: boolean;
  taskViewSelector: boolean;
  taskEditComment: boolean;
  taskDelete: boolean;
  taskEditStatus: boolean;
  taskCreateOnKanban: boolean;
  taskEditOthersDescriptions: boolean;
  taskMobileScreenshot: boolean;
  manageColumn: boolean;
  userHasConsented: boolean;
  annotateScreenshots: boolean;
  guestsSeeGuestsAllowed: boolean;
  guestsSeeGuests: boolean;
  editTaskUrl: boolean;
  viewPrivateComments: boolean;
  createPrivateComments: boolean;
  billing: boolean;
  taskRecordVideo: boolean;
  taskViewDueDate: boolean;
  createProject: boolean;
  deleteProject: boolean;
  taskEditVisibility: boolean;
  viewCommitComment: boolean;
  createTagsViaNewTask: boolean;
  aiSuggestedTitles: boolean;
  aiSuggestedTags: boolean;
  aiSuggestedTagsExistingOnly?: boolean;
  assignGuestsAllowed: boolean;
  assignGuests: boolean;
  viewLinkedTasks: boolean;
};
export interface User {
  id: number;
  email?: string;
  role?: Role | MemberRole;
  name: string;
  avatar?: string;
  avatarUrl?: string;
  accessTo?: AccessTo;
  accountConfirmed?: boolean;
  member?: boolean;
  surname?: string;
  first_name?: string;
  firstName?: string;
}
